import { ROUTE_PATHS } from 'routes/constants';

const STORED_TOKEN_NAMES = {
  ACCESS_TOKEN: 'accessToken',
  ACCESS_EXPIRES_ON: 'accessExpiresOn',
  REFRESH_TOKEN: 'refreshToken'
}; // check values in tokenize function (requestAgent.js)

export const LAST_USER_ACTIVITY_DATE_TIME = 'lastUserActivityDateTime';

export const LAST_SELECTED_ACCOUNT_NUMBER = 'lastSelectedAccountNumber';

const COMPACT_MENU = 'compactMenu';

// Preferences of the browser, not of the session - they are kept when the session data is cleared
const BROWSER_PREFERENCES = [COMPACT_MENU];

export const removeAccessToken = () => window.localStorage.removeItem(STORED_TOKEN_NAMES.ACCESS_TOKEN);

export const getAccessToken = () => window.localStorage.getItem(STORED_TOKEN_NAMES.ACCESS_TOKEN);

export const getRefreshToken = () => window.localStorage.getItem(STORED_TOKEN_NAMES.REFRESH_TOKEN);

export const getAccessExpiresOn = () => window.localStorage.getItem(STORED_TOKEN_NAMES.ACCESS_EXPIRES_ON);

export const clearLocalStorage = () => {
  const preferences = BROWSER_PREFERENCES.map((key) => [key, window.localStorage.getItem(key)]);

  window.localStorage.clear();
  preferences.forEach(([key, value]) => value !== null && window.localStorage.setItem(key, value));
};

export const isTokenValid = () => {
  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();
  const accessExpiresOn = getAccessExpiresOn();

  return accessToken && refreshToken && accessExpiresOn > Date.now();
};

export const setConfirmationActionType = (type) => localStorage.setItem('CONFIRMATION_TYPE', type);

export const getConfirmationActionType = () => localStorage.getItem('CONFIRMATION_TYPE');

export const removeConfirmationActionType = () => localStorage.removeItem('CONFIRMATION_TYPE');

export const setSecureUserPhone = (phone) => localStorage.setItem('SECURE_PHONE', phone);

export const getSecureUserPhone = () => localStorage.getItem('SECURE_PHONE');

export const saveTokenInfo = (info) =>
  Object.entries(info).map(([key, value]) => window.localStorage.setItem(key, value));

export const setLastUserActivityDateTime = () => localStorage.setItem(LAST_USER_ACTIVITY_DATE_TIME, new Date());

export const resetLastUserActivityDateTime = () => localStorage.setItem(LAST_USER_ACTIVITY_DATE_TIME, '');

export const getLastUserActivityDateTime = () => localStorage.getItem(LAST_USER_ACTIVITY_DATE_TIME);

export const setSelectedMultiAccount = (accountNumber) =>
  localStorage.setItem(LAST_SELECTED_ACCOUNT_NUMBER, accountNumber);

export const getSelectedMultiAccount = () => localStorage.getItem(LAST_SELECTED_ACCOUNT_NUMBER);

// The menu is collapsed until the operator expands it
export const getCompactMenuPreference = () => localStorage.getItem(COMPACT_MENU) !== 'false';

export const setCompactMenuPreference = (isCompact) => localStorage.setItem(COMPACT_MENU, String(isCompact));

export const logoutActiveSessionWithoutToken = () => {
  clearLocalStorage();
  window.location.href = ROUTE_PATHS.LOGIN;
};

const SESSION_EXPIRED_FLAG = 'sessionExpired';

// Used when the app detects a 401 from the backend (stale/revoked token) - marks the
// reason for the redirect so the login page can show a "session expired" message.
export const logoutDueToExpiredSession = () => {
  window.sessionStorage.setItem(SESSION_EXPIRED_FLAG, 'true');
  logoutActiveSessionWithoutToken();
};

// Reads and clears the flag set by logoutDueToExpiredSession - call once on the login page.
export const consumeSessionExpiredFlag = () => {
  const wasSessionExpired = window.sessionStorage.getItem(SESSION_EXPIRED_FLAG) === 'true';
  window.sessionStorage.removeItem(SESSION_EXPIRED_FLAG);

  return wasSessionExpired;
};

export const isActiveSession = () =>
  // eslint-disable-next-line max-len
  new Date() - new Date(getLastUserActivityDateTime()) < process.env.REACT_APP_PROLONGATION_MODAL_APPEARING_TIME * 1000;
